import { StatusIndicator } from "components/partials/status-indicator/status-indicator";
import TouchpointIcon from "containers/admin/clients/touchpoint/components/touchpoint-icon/touchpoint-icon";

import { findStatusDetails } from "utilities/touchpoint";
import { useGetTouchpointVersionStatusesQuery } from "hooks/api/dictionary/dictionary";

import { TouchpointType } from "types/touchpoint";

import Icons from "assets";

const SelectedItem = ({
  name,
  latestVersion,
  type,
  showStatus = false,
  showBatch = false,
  touchpointBatchName,
}: {
  name: string;
  latestVersion?: { id?: string; version?: number; status?: string | null } | null;
  type: TouchpointType;
  showStatus?: boolean;
  showBatch?: boolean;
  touchpointBatchName?: string;
}) => {
  const { data: touchpointVersionStatuses = [] } = useGetTouchpointVersionStatusesQuery();

  const latestVersionId = latestVersion?.id;
  const version = latestVersion?.version;
  const versionLabel = version === undefined || version === null ? undefined : `v${version}`;
  const status = latestVersion?.status ?? undefined;
  const statusDetails = findStatusDetails(status, touchpointVersionStatuses);

  const showVersionOrStatus = !!latestVersion && showStatus;
  const showBatchBadge = showBatch && !!touchpointBatchName;
  const showMetadata = showVersionOrStatus || showBatchBadge;

  return (
    <div className="flex items-start min-h-8 min-w-0 pl-3 text-sm font-normal text-gray-900">
      <div className="flex min-w-0 items-start gap-1 py-1.5">
        {/* mt-0.5 centres the 16px icon against the 20px first line of a possibly wrapping name */}
        <TouchpointIcon touchpointType={type} className="mt-0.5 size-4 shrink-0 text-gray-600" />
        <span
          id={latestVersionId ? `label-${latestVersionId}` : undefined}
          className="min-w-0 break-words text-inherit">
          {name}
        </span>
      </div>
      {showMetadata && (
        <div className="ml-3 flex shrink-0 items-center gap-3 py-1.5">
          {showVersionOrStatus && versionLabel && (
            <span className="whitespace-nowrap text-gray-500">{versionLabel}</span>
          )}
          {showVersionOrStatus && statusDetails && (
            <StatusIndicator versionStatuses={statusDetails} />
          )}
          {showBatchBadge && (
            <span
              className="flex shrink-0 items-center gap-1 text-xs text-gray-500"
              title={`Currently in batch: ${touchpointBatchName}`}>
              <Icons.Layers className="size-3.5 shrink-0" aria-hidden />
              <span className="line-clamp-1">{touchpointBatchName}</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectedItem;
